import { firebase } from '../config/configureFirebase';
import { onValue, set } from 'firebase/database';

export const FETCH_SAWI_SPECIAL = 'FETCH_SAWI_SPECIAL';
export const FETCH_SAWI_SPECIAL_SUCCESS = 'FETCH_SAWI_SPECIAL_SUCCESS';
export const FETCH_SAWI_SPECIAL_FAILED = 'FETCH_SAWI_SPECIAL_FAILED';
export const SAVE_SAWI_SPECIAL = 'SAVE_SAWI_SPECIAL';
export const SAVE_SAWI_SPECIAL_SUCCESS = 'SAVE_SAWI_SPECIAL_SUCCESS';
export const SAVE_SAWI_SPECIAL_FAILED = 'SAVE_SAWI_SPECIAL_FAILED';

export const fetchSawiSpecial = () => (dispatch) => {
    const { sawiSpecialRef } = firebase;
    dispatch({ type: FETCH_SAWI_SPECIAL });
    onValue(sawiSpecialRef, snapshot => {
        dispatch({ type: FETCH_SAWI_SPECIAL_SUCCESS, payload: snapshot.val() || {} });
    }, error => {
        dispatch({ type: FETCH_SAWI_SPECIAL_FAILED, payload: error.message });
    });
};

export const saveSawiSpecialCustomer = (data) => async (dispatch) => {
    const { sawiSpecialCustomerRef } = firebase;
    dispatch({ type: SAVE_SAWI_SPECIAL });
    try {
        await set(sawiSpecialCustomerRef, data);
        dispatch({ type: SAVE_SAWI_SPECIAL_SUCCESS });
    } catch (e) {
        dispatch({ type: SAVE_SAWI_SPECIAL_FAILED, payload: e.message });
    }
};

export const saveSawiSpecialDriver = (data) => async (dispatch) => {
    const { sawiSpecialDriverRef } = firebase;
    dispatch({ type: SAVE_SAWI_SPECIAL });
    try {
        await set(sawiSpecialDriverRef, data);
        dispatch({ type: SAVE_SAWI_SPECIAL_SUCCESS });
    } catch (e) {
        dispatch({ type: SAVE_SAWI_SPECIAL_FAILED, payload: e.message });
    }
};
